import { Component, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { VerticalTabComponent } from '../vertical-tab/vertical-tab';

const INDEX_ONE = 1;
@Component({
  selector: 'side-menu',
  templateUrl: 'side-menu.html'
})
export class SideMenuComponent {

  pages: any;
  passData: any;
  showCreate: boolean = true;
  showViewer: boolean = false;
  tabTemplates: any = [];
  tabName: any = 'ProposalCreate';
  selectedSegment: any;
  selectedTab: any;
  showPriceList: boolean = false;
  isTextFieldType1: boolean = false;
  broadcastSubs: any;
  @Output() pageContainer = new EventEmitter<any>();
  @ViewChild("insideElement") insideElement;
  constructor(public communicationServ: CommunicationServiceProvider, public componentService: ComponentServiceProvider, public dataService: DataServiceProvider) {
    this.pages = [
      { title: 'Proposal Viewer', id: 'ProposalViewer', component: VerticalTabComponent, classname: 'active' },
      { title: 'Proposal Create', id: 'ProposalCreate', component: VerticalTabComponent, classname: 'inactive' },
      { title: 'Price List', id: 'PriceList', component: VerticalTabComponent, classname: 'inactive' },
    ];
  }
  ngOnInit() {
    this.openSidebar();
    this.pageContainer.emit(this.pages[0]);
    document.getElementById("segmentCont").style.opacity = "0";
  }
  openSidebar(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'show-sidebar'){
        if(data.event === 'SIDEBAR'){
          let flag = data['status'];
    if (flag == true) {
      setTimeout(() => {
        document.getElementById("sideNav").style.width = "300px";
        document.getElementById("main").style.marginLeft = "300px";
        document.getElementById("segmentCont").style.opacity = "1";
      }, 100)
    } else {
      setTimeout(() => {
        document.getElementById("sideNav").style.width = "0px";
        document.getElementById("main").style.marginLeft = "0px";
        document.getElementById("segmentCont").style.opacity = "0";
      }, 100)
    }
  }
}
    });
  }
  openPage(data) {
    let pageActive: any;
    let pageInactive: any;
    pageInactive = this.pages.findIndex(x => x.classname == 'active')
    this.pages[pageInactive]['classname'] = "inactive";
    pageActive = this.pages.findIndex(x => x.title == data.title);
    this.pages[pageActive]['classname'] = "active";
    this.passData = { title: data.title, component: data.component };
    // localStorage.setItem('title', this.title);
    this.pageContainer.emit(data);
  }
  // @HostListener('document:click', ['$event.target'])
  // public onClick(targetElement) {
  //   const objLen = 0;
  //   if (this.insideElement) {
  //     const clickedInside = this.insideElement.nativeElement.contains(targetElement);
  //     if (clickedInside == false && targetElement.classList[objLen] != 'button-inner') {
  //       document.getElementById("sideNav").style.width = "0px";
  //       document.getElementById("main").style.marginLeft = "0px";
  //       document.getElementById("segmentCont").style.opacity = "0";
  //     } else {
  //       document.getElementById("sideNav").style.width = "300px";
  //       document.getElementById("main").style.marginLeft = "300px";
  //       document.getElementById("segmentCont").style.opacity = "1";
  //     }
  //   }
  // };
  loadPages(elem) {
    this.tabName = elem;
    if (elem == 'ProposalViewer') {
      this.showViewer = true;
      this.showCreate = false;
      this.showPriceList = false;
    } else if (elem == 'PriceList') {
      this.showPriceList = true;
      this.showViewer = false;
      this.showCreate = false;
    } else {
      this.showViewer = false;
      this.showCreate = true;
      this.showPriceList = false;
    }
    let index = this.componentService.tabTemplates.findIndex(item => item.id == this.tabName)
    this.tabTemplates = this.componentService.tabTemplates[index].templates;
    this.selectedSegment = JSON.stringify(INDEX_ONE);
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'OPEN_PAGE', params: this.tabTemplates[0] , tab: this.tabName});

  }
  openTabComponent(pageContent) {
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'OPEN_PAGE', params: pageContent, tab: this.tabName});
  }
  ngAfterViewInit() {
    document.getElementById("sideNav").style.width = "0px";
    document.getElementById("main").style.marginLeft = "0px";
    document.getElementById("segmentCont").style.opacity = "0";
    this.selectedTab = "list";
    let index = this.componentService.tabTemplates.findIndex(item => item.id == this.tabName)
    this.tabTemplates = this.componentService.tabTemplates[index].templates;
    this.selectedSegment = JSON.stringify(index);
  }
  ngOnDestroy() {
      this.broadcastSubs.unsubscribe();
  }
  toggleFieldType($event, idx) {
    if (this.tabTemplates[idx].selectIcon == true) {
      this.tabTemplates[idx].selectIcon = false;
    } else {
      this.tabTemplates[idx].selectIcon = true;
    }
  }
  ngAfterViewChecked() {
    var projectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
    var hwSwScreenData = JSON.parse(localStorage.getItem('HWSWScreenData'));
    var backupDrData = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
    var cloudData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
    var cyberScreenData = JSON.parse(localStorage.getItem('CYBERScreenData'));
    var mspScreenData = JSON.parse(localStorage.getItem('MSPScreenData'));
    if(document.getElementsByClassName("viewIcon").length >= 1 && this.tabName == 'ProposalViewer'){
    if(projectScreenData != null){
      if(projectScreenData.projectService.TotalProjectService != '' || projectScreenData.Hslw.totalHslw != ''){
        this.tabTemplates[6].selectIcon = false;
      }else{
        this.tabTemplates[6].selectIcon = true;
      }
    }else{
      this.tabTemplates[6].selectIcon = true;
    }

    if(hwSwScreenData != null){
      if(hwSwScreenData.TotalExtendedPrice != ''){
        this.tabTemplates[5].selectIcon = false;
      }else{
        this.tabTemplates[5].selectIcon = true;
      }
    }else{
      this.tabTemplates[5].selectIcon = true;
    }

    if(backupDrData != null){
      if(backupDrData.totalBackupDrServiceOneTimeFees != '' || backupDrData.BackupFeesummaryTotaly != ''){
        this.tabTemplates[4].selectIcon = false;
      }else{
        this.tabTemplates[4].selectIcon = true;
      }
    }else{
      this.tabTemplates[4].selectIcon = true;
    }

    if(cloudData != null){
      if(cloudData.FeesummaryMonthlyTotal != '' || cloudData.TotalStartUp != ''){
        this.tabTemplates[3].selectIcon = false;
      }else{
        this.tabTemplates[3].selectIcon = true;
      }
    }else{
      this.tabTemplates[3].selectIcon = true;
    }

    if(cyberScreenData != null){
      if(cyberScreenData.oneTimeFee.TotalStartUp != '' || cyberScreenData.totalBackupDrMonthlyTool != ''){
        this.tabTemplates[2].selectIcon = false;
      }else{
        this.tabTemplates[2].selectIcon = true;
      }
    }else{
      this.tabTemplates[2].selectIcon = true;
    }

    if(mspScreenData != null){
      if(mspScreenData.miscProductService.totalManagedServiceOneTimeFees != '' || mspScreenData.mspFeesummaryTotal != ''){
        this.tabTemplates[1].selectIcon = false;
      }else{
        this.tabTemplates[1].selectIcon = true;
      }
    }else{
      this.tabTemplates[1].selectIcon = true;
    }
  }
  }
}



// WEBPACK FOOTER //
// ./src/components/side-menu/side-menu.ts